import React from 'react';
import { IonButton, IonButtons, IonFooter, IonToolbar } from '@ionic/react';

const WizardFooter = ({ currentStep, onBack, onNext }) => {
    return (
        <IonFooter>
            <IonToolbar>
                <IonButtons slot="start" style={{ marginLeft: 12 }}>
                    {(currentStep === 2 || currentStep === 3) && (
                        <IonButton fill="outline" onClick={onBack}>Back</IonButton>
                    )}
                </IonButtons>
                <IonButtons slot="end" style={{ marginRight: 12 }}>
                    {(currentStep === 1 || currentStep === 2) && (
                        <IonButton onClick={onNext} fill="solid" color="primary">Next</IonButton>
                    )}
                </IonButtons>
            </IonToolbar>
        </IonFooter>
    );
};

export default WizardFooter;


